import { Null, Number, Record, Static, String } from "runtypes";

export const ResponseSummaryResponseRuntype = Record({
  coachId: Number,
  parentSummary: String.Or(Null),
  studentSummary: String,
  surveyQuestionId: Number,
});

export interface IResponseSummaryResponse
  extends Static<typeof ResponseSummaryResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/services/IResponseSummaryResponse.ts